/**
 * 导入工具类
 */
import { isAndroid } from './utils/index';

/**
 * 导入初始化方法
 */
import { setupWebViewJavascriptBridge } from './bridge/bridge';

/**
 * 初始化
 */
setupWebViewJavascriptBridge((bidge: WebViewBridge) => {
  if (isAndroid()) {
    bidge.init((message: string, responseCallback: (val: string) => void) => {
      console.warn(message);
      if (responseCallback) {
        responseCallback('Android init');
      }
    });
  }
});

/**
 * 导出所有bridge调用方法
 */
export {
  closeWebView,
  openStockDetail,
  openStockDetailsWithRange,
  getSelfStocks,
  getNewsTabList,
  getUserInfo,
  openWeChat,
  getLocalUuid,
  getSystemTheme,
  openPdf,
  getAppVersion,
  callPhone,
  nativeToast,
  openLiveUrl,
  openWebviewUrl,
  openCourseShareDialog,
  getStatusBarHeight,
  getNativeTheme,
  chooseImage,
  exitApp,
  openFiancePage,
  openOptionalStockPage,
  openSelectStock,
  answerDialogDismiss,
  logOut,
  callUpdateEvent,
  disableLeftSwipeClose,
  openCamera,
  requestRecordPermission,
  chooseImageMulti,
  setScreenOnStatus,
  openExternalLink,
  openShareDialog,
  openShowCourseDialog,
  iosSystemVersion,
  vibrate,
  triggerAppShare,
  getIsNeedJumpToWechatButtonForIOS,
  copyText,
  setNativeStorage,
  getNativeStorage,
} from './bridge/callHandler';

/**
 * 导出所有bridge注册方法
 */
export { setEventWatchCloseWebview, setEventWatchThemeChange, setEventWatchUpdate, setEventWatchMultiChooseImage, setEventWatchKeyboardVisibilityChange, triggerAIQuestion } from './bridge/registerHandler';

/**
 * 导出工具方法
 */
export { isAndroid, isIOS, isInApp } from './utils/index';
